import type { FC } from 'react';

import { Box, Button, FavoriteButton } from '@opendoor/bricks-next';

interface FloatingCTAProps {
  ctaText: string;
  onClickCta: () => void;
  ctaHref?: string;
  ctaAnalyticsName?: string;
  isLiked?: boolean;
  onClickReaction?: () => void;
  variant?: 'secondary' | 'primary' | 'secondaryInverse';
  isVisible?: boolean;
  disabled?: boolean;
  // Secondary button props
  showSecondaryButton?: boolean;
  secondaryButtonText?: string;
  secondaryButtonHref?: string;
  onClickSecondary?: () => void;
  secondaryAnalyticsName?: string;
}

export const FloatingCTA: FC<FloatingCTAProps> = ({
  ctaText,
  onClickCta,
  ctaHref,
  ctaAnalyticsName = 'cosmos-marketplace-footer-cta',
  isLiked,
  onClickReaction,
  variant = 'primary',
  isVisible = true,
  disabled = false,
  showSecondaryButton = false,
  secondaryButtonText,
  secondaryButtonHref,
  onClickSecondary,
  secondaryAnalyticsName = 'cosmos-marketplace-footer-secondary-cta',
}) => {
  return (
    <Box // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      position="sticky"
      zIndex={4}
      bottom={0}
      width="100%"
      $smallerThanMD={{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        position: 'fixed',
        paddingHorizontal: '$6x',
        paddingBottom: '$6x',
      }}
      $largerThanSM={{
        paddingHorizontal: '$12x',
        paddingBottom: '$12x',
      }}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
        pointerEvents: isVisible ? 'auto' : 'none',
      }}
    >
      <Box
        backgroundColor="$backgroundPrimary"
        borderRadius="$12x"
        borderWidth={0.5}
        borderColor="$borderStateHoverTertiary"
        shadow="$pressed"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <FavoriteButton
          analyticsName="cosmos-marketplace-pdp-favorite"
          onPress={onClickReaction}
          size="medium"
          variant="default"
          ml={16}
          my={12}
          isFavorited={isLiked}
        />
        <Box flexDirection="row" gap="$4x" alignItems="center" mr={12} my={12}>
          {showSecondaryButton && secondaryButtonText && (
            <Button
              analyticsName={secondaryAnalyticsName}
              aria-label={secondaryButtonText}
              variant="secondary"
              size="small"
              onPress={onClickSecondary}
              label={secondaryButtonText}
              href={secondaryButtonHref}
              target="_blank"
              rel="noopener"
            />
          )}
          <Button
            analyticsName={ctaAnalyticsName}
            aria-label={ctaText}
            variant={variant}
            size="small"
            onPress={onClickCta}
            label={ctaText}
            href={ctaHref}
            target="_blank"
            rel="noopener"
            disabled={disabled}
          />
        </Box>
      </Box>
    </Box>
  );
};
